// src/CountryInfo.js

import React, { useState } from 'react';
import './CountryInfo.css';

const countryData = {
    "USA": {
      capital: "Washington, D.C.",
      states: 50,
      gdp: "21.43 trillion USD",
      speciality: "World's largest economy",
      game: "Baseball",
      languages: ["English", "Spanish", "Chinese"],
      otherSpecialities: [
        "Hollywood - global film industry",
        "Silicon Valley - tech innovation",
        "Grand Canyon - natural wonder",
        "NASCAR - motorsport",
        "Jazz music - cultural heritage"
      ]
    },
    "India": {
      capital: "New Delhi",
      states: 28,
      gdp: "2.87 trillion USD",
      speciality: "Largest democracy in the world",
      game: "Cricket",
      languages: ["Hindi", "English", "Bengali"],
      otherSpecialities: [
        "Bollywood - film industry",
        "IT Hub - technology services",
        "Yoga - wellness practice",
        "Taj Mahal - historical monument",
        "Cuisine - diverse culinary heritage"
      ]
    },
    "Japan": {
      capital: "Tokyo",
      states: "47 prefectures",
      gdp: "5.15 trillion USD",
      speciality: "Technology and innovation",
      game: "Sumo wrestling",
      languages: ["Japanese"],
      otherSpecialities: [
        "Anime - Japanese animation",
        "Sakura - cherry blossoms",
        "Tea ceremonies",
        "High-speed trains (Shinkansen)",
        "Mount Fuji - iconic landmark"
      ]
    },
    "United Kingdom": {
      capital: "London",
      states: "4 countries (England, Scotland, Wales, Northern Ireland)",
      gdp: "2.83 trillion USD",
      speciality: "Historical and cultural heritage",
      game: "Football (soccer)",
      languages: ["English"],
      otherSpecialities: [
        "Monarchy - royal family",
        "Stonehenge - ancient monument",
        "Oxford and Cambridge - prestigious universities",
        "British Museum - rich collection",
        "Literature - Shakespeare, Dickens"
      ]
    },
    "Australia": {
      capital: "Canberra",
      states: "6 states and 2 territories",
      gdp: "1.40 trillion USD",
      speciality: "Unique wildlife and natural landscapes",
      game: "Cricket",
      languages: ["English"],
      otherSpecialities: [
        "Great Barrier Reef - marine biodiversity",
        "Sydney Opera House - architectural marvel",
        "Outback - vast remote interior",
        "Indigenous culture and art",
        "Sports - rugby, surfing"
      ]
    },
    "China": {
      capital: "Beijing",
      states:" 23 provinces, 5 autonomous regions, 4 direct-controlled municipalities, 2 Special Administrative Regions",
      gdp: "14.34 trillion USD",
      speciality: "Largest population in the world",
      game: "Table tennis",
      languages: ["Mandarin"],
      otherSpecialities: [
        "Great Wall of China",
        "Silk Road - ancient trade route",
        "Chinese cuisine - diverse regional dishes",
        "Traditional festivals - Chinese New Year",
        "Terracotta Army - historical artifact"
      ]
    },
    "Germany": {
      capital: "Berlin",
      states:" 16 federal states",
      gdp: "3.86 trillion USD",
      speciality: "Engineering and manufacturing",
      game: "Football (soccer)",
      languages: ["German"],
      otherSpecialities: [
        "Oktoberfest - beer festival",
        "Automobile industry - BMW, Volkswagen",
        "Berlin Wall - historical significance",
        "Classical music - Beethoven, Bach",
        "Efficient public transport"
      ]
    },
    "Canada": {
      capital: "Ottawa",
      states: "10 provinces and 3 territories",
      gdp: "1.73 trillion USD",
      speciality: "Vast natural landscapes",
      game: "Ice hockey",
      languages: ["English", "French"],
      otherSpecialities: [
        "Niagara Falls - natural wonder",
        "Maple syrup",
        "Multicultural society",
        "Rocky Mountains - scenic beauty",
        "Wildlife - bears, moose"
      ]
    },
    "Italy": {
      capital: "Rome",
      states: "20 regions",
      gdp: "2.00 trillion USD",
      speciality: "Art, history, and cuisine",
      game: "Football (soccer)",
      languages: ["Italian"],
      otherSpecialities: [
        "Vatican City - religious significance",
        "Renaissance art - Michelangelo, Da Vinci",
        "Pasta and pizza",
        "Fashion - Milan",
        "Historical sites - Colosseum, Venice"
      ]
    },
    "South Africa": {
      capital: "Pretoria (executive), Bloemfontein (judicial), Cape Town (legislative)",
      states: "9 provinces",
      gdp: "351 billion USD",
      speciality: "Diverse culture and natural beauty",
      game: "Rugby",
      languages: ["Zulu", "Xhosa", "Afrikaans", "English"],
      otherSpecialities: [
        "Wildlife safaris - Kruger National Park",
        "Table Mountain - natural landmark",
        "Wine regions - Stellenbosch",
        "Nelson Mandela - historical figure",
        "Cultural festivals - arts and music"
      ]
    },
    "Brazil": {
      capital: "Brasilia",
      states: "26 states and 1 federal district",
      gdp: "2.05 trillion USD",
      speciality: "Largest coffee producer",
      game: "Football (soccer)",
      languages: ["Portuguese"],
      otherSpecialities: [
        "Amazon Rainforest - biodiversity",
        "Carnival - vibrant festival",
        "Samba and Bossa Nova - music",
        "Christ the Redeemer - iconic statue",
        "Pantanal - wildlife sanctuary"
      ]
    },
    "France": {
      capital: "Paris",
      states: "18 administrative regions",
      gdp: "2.78 trillion USD",
      speciality: "Art and culture",
      game: "Football (soccer)",
      languages: ["French"],
      otherSpecialities: [
        "Eiffel Tower - iconic landmark",
        "French cuisine - wine, cheese",
        "Fashion - Paris",
        "Louvre Museum - art collection",
        "Historical sites - Versailles, Notre Dame"
      ]
    },
    "Russia": {
      capital: "Moscow",
      states: "85 federal subjects",
      gdp: "1.64 trillion USD",
      speciality: "Largest country by land area",
      game: "Ice hockey",
      languages: ["Russian"],
      otherSpecialities: [
        "Trans-Siberian Railway",
        "Red Square and Kremlin - historical sites",
        "Classical literature - Tolstoy, Dostoevsky",
        "Vodka",
        "Ballet - Bolshoi Theatre"
      ]
    },
    "Mexico": {
      capital: "Mexico City",
      states: "32 federal entities",
      gdp: "1.22 trillion USD",
      speciality: "Rich cultural heritage",
      game: "Football (soccer)",
      languages: ["Spanish"],
      otherSpecialities: [
        "Mayan and Aztec ruins",
        "Mexican cuisine - tacos, guacamole",
        "Day of the Dead festival",
        "Tequila",
        "Mariachi music"
      ]
    },
    "United Arab Emirates": {
      capital: "Abu Dhabi",
      states: "7 emirates",
      gdp: "421 billion USD",
      speciality: "Modern architecture and luxury",
      game: "Football (soccer)",
      languages: ["Arabic"],
      otherSpecialities: [
        "Burj Khalifa - tallest building",
        "Desert safaris",
        "Luxury shopping - Dubai Mall",
        "Palm Jumeirah - man-made island",
        "Cultural heritage - souks, museums"
      ]
    },
    "Spain": {
      capital: "Madrid",
      states: "17 autonomous communities and 2 autonomous cities",
      gdp: "1.39 trillion USD",
      speciality: "Art and architecture",
      game: "Football (soccer)",
      languages: ["Spanish", "Catalan", "Galician", "Basque"],
      otherSpecialities: [
        "Flamenco - traditional dance",
        "Paella - national dish",
        "La Sagrada Familia - architectural marvel",
        "Bullfighting",
        "Festivals - La Tomatina, Running of the Bulls"
      ]
    },
    "Argentina": {
      capital: "Buenos Aires",
      states: "23 provinces and 1 autonomous city",
      gdp: "449 billion USD",
      speciality: "Rich cultural heritage",
      game: "Football (soccer)",
      languages: ["Spanish"],
      otherSpecialities: [
        "Tango - traditional dance",
        "Patagonia - scenic landscapes",
        "Argentinian beef - culinary delight",
        "Iguazu Falls - natural wonder",
        "Wine - Malbec"
      ]
    },

  // Add more countries as needed
};

const CountryInfo = () => {
  const [selectedCountry, setSelectedCountry] = useState('USA');
  const [readAloud, setReadAloud] = useState(false);

  const handleCountryChange = (e) => {
    setSelectedCountry(e.target.value);
  };

  const handleReadAloud = () => {
    const country = countryData[selectedCountry];
    const utterance = new SpeechSynthesisUtterance(
      `The capital of ${selectedCountry} is ${country.capital}. It has ${country.states} states. The GDP is ${country.gdp}. The country speciality is ${country.speciality}. The national game is ${country.game}. The top three languages are ${country.languages.join(", ")}. Other specialities include ${country.otherSpecialities.join(", ")}.`
    );
    speechSynthesis.speak(utterance);
    setReadAloud(true);
  };

  const country = countryData[selectedCountry];

  return (
    <div className="country-info">
      <h1>Country Information</h1>
      <div>
        <label>
          Select Country:
          <select value={selectedCountry} onChange={handleCountryChange}>
            {Object.keys(countryData).map((country) => (
              <option key={country} value={country}>{country}</option>
            ))}
          </select>
        </label>
      </div>
      <div className="info">
        <h2>{selectedCountry}</h2>
        <p><strong>Capital:</strong> {country.capital}</p>
        <p><strong>Number of States:</strong> {country.states}</p>
        <p><strong>GDP:</strong> {country.gdp}</p>
        <p><strong>Speciality:</strong> {country.speciality}</p>
        <p><strong>National Game:</strong> {country.game}</p>
        <p><strong>Top 3 Languages:</strong> {country.languages.join(", ")}</p>
        <p><strong>Other Specialities:</strong></p>
        <ul>
          {country.otherSpecialities.map((speciality, index) => (
            <li key={index}>{speciality}</li>
          ))}
        </ul>
      </div>
      <button onClick={handleReadAloud}>Read Aloud</button>
    </div>
  );
};

export default CountryInfo;
